var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPatientAccounts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nE13Cn.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.26,24c-.46-.12-.95-.45-1.13-.9-.03-.07-.13-.43-.13-.48v-2.6h-2.6c-.51,0-1.13-.53-1.29-1.01-.17-.52-.16-1.83.13-2.31.21-.33.76-.72,1.16-.72h2.6v-2.6c0-.4.39-.95.72-1.16.47-.3,1.79-.31,2.3-.13.48.16,1,.78,1,1.29v2.6h2.6s.41.1.48.13c.46.18.78.67.9,1.13v1.5c-.12.45-.4.9-.84,1.1-.08.04-.47.16-.54.16h-2.6v2.6c0,.06-.13.46-.16.54-.2.44-.65.72-1.1.84h-1.5ZM19.15,16.86c-.09-.09-.14-.26-.16-.38l-.02-3.17c-.12-.41-1.06-.36-1.41-.33-.23.03-.5.15-.54.4-.09.98.11,2.13,0,3.09-.04.32-.21.5-.54.54-.96.11-2.11-.08-3.09,0-.2.03-.34.23-.38.42-.07.34-.11,1.4.3,1.53l3.35.07c.22.07.32.27.35.49.11.96-.08,2.11,0,3.09.03.2.23.34.42.38.34.07,1.4.11,1.53-.3l.07-3.36c.07-.22.27-.32.49-.35.96-.11,2.11.08,3.09,0,.2-.03.34-.23.38-.42.07-.34.11-1.4-.3-1.53l-3.16-.02c-.12-.01-.3-.07-.38-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.7,20.02c.41.09.44.89-.1.98H.57c-.3,0-.52-.19-.54-.49.07-1.41-.1-2.91,0-4.31.15-2.24,2.01-4.06,4.24-4.19,3.01-.19,6.2.15,9.23,0,.61.02.72.8.14.98H4.45c-1.68,0-3.44,1.6-3.44,3.31v3.66l.07.07h8.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.59.02c4.13-.34,6.88,4.21,4.62,7.72-1.91,2.96-6.31,3.03-8.3.11C2.75,4.68,4.79.33,8.59.02ZM8.82,1c-2.97.15-4.77,3.45-3.24,6.03s5.29,2.62,6.85.06c1.67-2.74-.42-6.25-3.61-6.09Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPatientAccounts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/patient-accounts.653164f47d729361b182deabfcb60669.svg";